import cx from 'clsx';
import React, { FunctionComponent, useContext } from 'react';
import styles from './Header.module.scss';
import { MobileNavigation, DesktopNavigation } from 'components/presentional';
import { useMenu } from 'hooks';
import { LanguageContext } from 'context';
import utilityStyles from 'styles/global/utility.module.scss';

interface OwnProps {}

type HeaderProps = Omit<JSX.IntrinsicElements['header'], 'children'> & OwnProps;

const Header: FunctionComponent<HeaderProps> = props => {
  const { className, ...rest } = props;
  const { language } = useContext(LanguageContext);
  const { data: mainMenu } = useMenu({ slug: `main-menu${language !== 'pl' ? `-${language}` : ''}` });
  const { data: topMenu } = useMenu({ slug: `main-top-menu${language !== 'pl' ? `-${language}` : ''}` });

  const headerClassName = cx({
    [styles.header]: true,
    ...(className && { [className]: true }),
  });

  const desktopClassNames = cx({
    [styles.desktop]: true,
    [utilityStyles.elevation1]: true,
  });

  return (
    <header className={headerClassName} {...rest}>
      <DesktopNavigation className={desktopClassNames} topMenu={topMenu} mainMenu={mainMenu} />
      <MobileNavigation className={styles.mobile} topMenu={topMenu} mainMenu={mainMenu} />
    </header>
  );
};

export default Header;
